// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    projectId: "etp-paint-shop",
    appId: "1:458001308208:web:17829161d8f1b5bcdd2bf5",
    storageBucket: "etp-paint-shop.appspot.com",
    locationId: "asia-south1",
    apiKey: "AIzaSyBFLy4Rb3LUCddZq1A_y7A218j9SvlKCVA",
    authDomain: "etp-paint-shop.firebaseapp.com",
    messagingSenderId: "458001308208",
    measurementId: "G-33KDM753N9",
  },
  build_number: 0,
  mode: "firebase",
  appVersion: "1.0.0",
  api_endpoint: "firebase",
  socket_endpoint: "http://localhost:1990",
  dev: true,
  cloud: true,
  firestore_collection_url: "/DATA/VECV",
  // cloudFunctionUrl:"https://asia-south1-las-prod-1.cloudfunctions.net/PredictAI_JSPL/",
  cloudFunctionUrl:
    "https://asia-south1-etp-paint-shop.cloudfunctions.net/vecv-paint-shop/",
  testFunction:
    "https://asia-south1-las-prod-1.cloudfunctions.net/testingPredictAI_JSPL/",
  prod_tracking: "G-N7Z8Z7E946",
  productId: "VECV_0001",
  authenticationKey: "237f306841bd23a418878792252ff6c8",
  firebasetokenApi: '/Custom-Token-Authentication/generateCustomToken',
  firebasetokenKey: 'ayiaP3456ayidivehT34iloalakko',
  localToken: '30m05a20y23@13:13'

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
